module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "xl-footer"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../images/footer_nav_49.png"),
      "alt": "闲徕互娱"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2019 - 2020 "), _c('a', {
    staticStyle: {
      "color": "#99999d",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("京ICP备16022346号-4")]), _vm._v("   京网文[2016]1755-215号")]), _vm._v(" "), _c('p', [_vm._v("增值电信业务经营许可证 京B2-20170093")]), _vm._v(" "), _c('p', [_vm._v("健康游戏公告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防上当受骗 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活")]), _vm._v(" "), _c('p', [_vm._v("未满18周岁的未成年人用户请在家长的监督下进行游戏")]), _vm._v(" "), _c('p', [_vm._v("举报邮箱：jubao@xianlai-inc.com ")]), _vm._v(" "), _c('p', [_vm._v("北京闲徕互娱网络科技有限公司版权所有")]), _vm._v(" "), _c('p', [_vm._v("地址：北京市朝阳区天朗园C座3层03商业3-008")]), _vm._v(" "), _c('p', [_vm._v(" 电话：010-84935767")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c21173da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Footer.vue
// module id = 263
// module chunks = 1